import * as React from 'react'

const JpgIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <g clipPath="url(#clip0_7337_43606)">
        <path
          fill="#E9F0FA"
          d="m18 0 4 4v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
        ></path>
        <path fill="#C2CDDE" d="M22 4h-4V0z"></path>
      </g>
      <rect width="22" height="10" x="1" y="10" fill="#C548F1" rx="1"></rect>
      <path
        fill="#fff"
        d="M7.033 12.182H8.08v4.09q-.003.564-.239.97a1.6 1.6 0 0 1-.659.622q-.42.215-.98.215-.511 0-.92-.181a1.5 1.5 0 0 1-.645-.546q-.24-.36-.239-.898h1.048a.8.8 0 0 0 .103.407q.103.17.28.261.18.09.413.091a.8.8 0 0 0 .429-.105.68.68 0 0 0 .267-.318q.093-.21.096-.517zM9.223 18v-5.818h2.181q.67 0 1.125.25.458.25.69.687.236.435.236.989 0 .56-.236.994-.235.435-.696.685-.46.247-1.133.247H9.944v-.866h1.304q.392 0 .642-.137a.86.86 0 0 0 .37-.375q.12-.239.121-.548 0-.31-.122-.546a.83.83 0 0 0-.372-.366q-.25-.133-.645-.133h-.966V18zm9.045-3.96a1.5 1.5 0 0 0-.196-.412 1.3 1.3 0 0 0-.295-.316 1.2 1.2 0 0 0-.392-.195 1.6 1.6 0 0 0-.483-.069q-.468 0-.835.236a1.6 1.6 0 0 0-.577.693q-.207.455-.207 1.108 0 .66.207 1.117t.577.696q.369.236.858.236.442 0 .767-.17.326-.172.503-.484a1.5 1.5 0 0 0 .176-.739l.238.037h-1.58v-.824h2.362v.7q0 .746-.319 1.292a2.17 2.17 0 0 1-.875.84 2.7 2.7 0 0 1-1.278.293q-.804 0-1.412-.36a2.5 2.5 0 0 1-.946-1.032q-.338-.67-.338-1.59 0-.705.199-1.259.202-.555.562-.94.36-.39.847-.591a2.7 2.7 0 0 1 1.057-.205q.483 0 .9.142.418.14.742.398.327.258.537.614.21.354.275.784z"
      ></path>
      <defs>
        <clipPath id="clip0_7337_43606">
          <path fill="#fff" d="M2 0h20v24H2z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
)

JpgIcon.displayName = 'JpgIcon'

export { JpgIcon }
